let soap = [
    {
        id:0,
        title:"퍼퓸 비누 카모 트레이 세트",
        imgUrl:"/img/soap.jpg",
        content:"진득한 카모마일 | 부드러운 나무결 | 머스크",
        price:43500,
        text:"퍼퓸 비누와 전용 트레이로 구성 된 세트 제품입니다. \n\n\ 꿀처럼 진득하고 달콤한 카모마일과 씁쓸한 클라리세이지의 허브 향이 오묘한 조화를 \n 이루어 중독성 있는 향을 선사합니다. \n\n자연을 닮은 탬버린즈 퍼퓸 비누는 화학적인 성분을 최대한 배제하고 작물의 수확에서\n  오는 건강함을 온전히 전하고자 식물유래 성분을 사용하여 피부 pH와 유사한 약산성\n 성분의  비누로 만들어졌습니다. \n\n작물을 수확할 때의 기쁨을 형상화한 퍼퓸 비누."

    },
    
    {
        id:1,
        title:"퍼퓸 비누 버가샌달 트레이 세트",
        imgUrl:"/img/soap2.jpg",
        content:"지중해의 베르가뭇 | 쌉싸래한 청귤 | 샌달우드",
        price:43500,
        text:"퍼퓸 비누와 전용 트레이로 구성 된 세트 제품입니다. \n\n\ 지중해의 푸릇한 기운을 받고 자란 베르가못의 청량한 향에 라임 카다멈의 신선하고 \n 쌉싸래한 향이 더해져 따사로운 햇볕 아래 서서히 익어가는 청귤을 떠오르게 합니다. \n\n 자연을 닮은 탬버린즈 퍼퓸 비누는 화학적인 성분을 최대한 배제하고 작물의 수확에서\n 오는 건강함을 온전히 전하고자 식물유래 성분을 사용하여 피부 pH와 유사한 약산성 \n성분의 비누로 만들어졌습니다. \n\n\ 작물을 수확할 때의 기쁨을 형상화한 퍼퓸 비누."},

    {
        id:2,
        title:"퍼퓸 비누 라레 트레이 세트",
        imgUrl:"/img/soap3.jpg",
        content:"이슬을 머금은 풋사과 | 화이트 튤립 | 샌달우드",
        price:43500,
        text:"퍼퓸 비누와 전용 트레이로 구성 된 세트 제품입니다. \n\n\ 튤립의 첫 이름을 의미하는 라레는 새벽의 이슬을 머금은 청초한 푸른 사과를 한 입 베어 문 듯 청량하면서도 절제된 달콤함을 시작으로, 잔잔한 그린 플로럴의 향취가 화이트 튤립의\n 싱그러운 푸른 잎사귀를 떠오르게 합니다. \n\n\ 자연을 닮은 탬버린즈 퍼퓸 비누는 화학적인 성분을 최대한 배제하고 작물의 수확에서\n 오는 건강함을 온전히 전하고자 식물유래 성분을 사용하여 피부 pH와 유사한 약산성\n 성분의 비누로 만들어졌습니다. \n\n\ 작물을 수확할 때의 기쁨을 형상화한 퍼퓸 비누."
    },

    {
        id:3,
        title:"퍼퓸 비누 화이트다즐링 트레이 세트",
        imgUrl:"/img/soap4.jpg",
        content:"화이트 샴페인 | 다즐링 티 | 크리미한 머스크",
        price:43500,
        text:"퍼퓸 비누와 전용 트레이로 구성 된 세트 제품입니다. \n\n\ 화이트 샴페인의 섬세한 거품과 달달한 과일향에 씁쓸한 다즐링 차 향이 풍성하고 조화롭게 어우러져 찻잔 속에서 추는 우아한 향의 춤의 향연을 선사합니다. \n\n\ 자연을 닮은 탬버린즈 퍼퓸 비누는 화학적인 성분을 최대한 배제하고 작물의 수확에서\n 오는 건강함을 온전히 전하고자 식물유래 성분을 사용하여 피부 pH와 유사한 약산성\n 성분의 비누로 만들어졌습니다. \n\n\ 작물을 수확할 때의 기쁨을 형상화한 퍼퓸 비누."
    }

    
]

export default soap; 